<template>
  <div class="customitem-component">
    <p v-for="(item, index) in labe_list" :key="index">{{item}}</p>
  </div>
</template>

<script>
  export default {
    props: {
      labe_list: Array
    },
  }
</script>

<style scoped>
  .customitem-component {
    background: #FFFFFF;
    height: auto;
    width: 200px;
    font-size: 20px;
    border-radius: 5px;
    border: 2px solid rgb(31, 147, 255);
    position: relative;
    box-shadow: 0 0 10px #333;
  }
</style>
